import { Pagination } from "@/modules/common/types/Pagination";
import api from "../api";
import { ImportAneelTariffsDto, ListAneelTariffImportHistoryDto, ListAneelTariffsDto } from "../dto/admin-aneel-tariffs";
import {
  AdminAneelTariffImportHistoryResponse,
  AdminAneelTariffLastUpdateResponse,
  AdminAneelTariffResponse,
  ImportAneelTariffsResponse,
} from "../response/admin-aneel-tariffs";

export const ADMIN_ANEEL_TARIFFS_ENDPOINTS = {
  GET_TARIFFS: "/v1/admin/aneel-tariffs",
  GET_IMPORT_HISTORY: "/v1/admin/aneel-tariffs/import-history",
  GET_LAST_UPDATE: "/v1/admin/aneel-tariffs/last-update",
  IMPORT_TARIFFS: "/v1/admin/aneel-tariffs/import",
};

export const AdminAneelTariffs = {
  getTariffs: async (params: ListAneelTariffsDto): Promise<Pagination<AdminAneelTariffResponse>> => {
    const response = await api.get(ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_TARIFFS, {
      params,
    });
    return response.data;
  },

  getImportHistory: async (params: ListAneelTariffImportHistoryDto): Promise<Pagination<AdminAneelTariffImportHistoryResponse>> => {
    const response = await api.get(ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_IMPORT_HISTORY, { params });
    return response.data;
  },

  getLastUpdate: async (): Promise<AdminAneelTariffLastUpdateResponse> => {
    const response = await api.get(ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_LAST_UPDATE);
    return response.data;
  },

  importTariffs: async (data: ImportAneelTariffsDto): Promise<ImportAneelTariffsResponse> => {
    const response = await api.post(ADMIN_ANEEL_TARIFFS_ENDPOINTS.IMPORT_TARIFFS, data);
    return response.data;
  },
};
